function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#_\uAE08\uC0C9);\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill-rule: evenodd;\n      }\n\n      .cls-6 {\n        fill: none;\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-7 {\n        fill: #e4c680;\n      }\n\n      .cls-8 {\n        fill: url(#_\uAE08\uC0C9-5);\n      }\n\n      .cls-9 {\n        fill: url(#_\uAE08\uC0C9-3);\n      }\n\n      .cls-10 {\n        fill: url(#_\uAE08\uC0C9-6);\n      }\n\n      .cls-11 {\n        fill: url(#_\uAE08\uC0C9-4);\n      }\n\n      .cls-12 {\n        fill: url(#_\uAE08\uC0C9-2);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: #fff;\n        mix-blend-mode: soft-light;\n        opacity: .25;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 218.75,
  y1: 586.46,
  x2: 218.75,
  y2: -141.52,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#dcb551"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#f8f6ce"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#decba4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#b1884b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#fdfbdf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#d8c378"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#d5be7e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ece8c5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e4d8a7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 218.74,
  y1: 570.5,
  x2: 218.74,
  y2: -122.84,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#6d4021"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#784c25"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#936830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#9e7334"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#90642d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#885b2a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#9a7442"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#ccb883"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#ece3ab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#f8f4bb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#f6eeb4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#f2e0a4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f1dfa3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 9.49,
  y1: 251.33,
  x2: 428,
  y2: 251.33,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: -31.67,
  cy: -42.58,
  fx: -31.67,
  fy: -42.58,
  r: 444.71,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#333"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#1a1a1a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#040000"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 213.56,
  y1: 178.2,
  x2: 224.88,
  y2: 124.84,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 345.41,
  y1: 269.18,
  x2: 415.16,
  y2: 227.33,
  gradientTransform: "translate(-230.02 281.36) rotate(47.05) scale(1 -1)",
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 340.71,
  y1: 261.45,
  x2: 410.5,
  y2: 219.58,
  gradientTransform: "translate(-230.02 281.36) rotate(47.05) scale(1 -1)",
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 333.35,
  y1: 249.19,
  x2: 403.14,
  y2: 207.32,
  gradientTransform: "translate(-230.02 281.36) rotate(47.05) scale(1 -1)",
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 330.91,
  y1: 244.77,
  x2: 400.5,
  y2: 203.02,
  gradientTransform: "translate(-230.02 281.36) rotate(47.05) scale(1 -1)",
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: 326.57,
  y1: 237.64,
  x2: 396.21,
  y2: 195.86,
  gradientTransform: "translate(-230.02 281.36) rotate(47.05) scale(1 -1)",
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: 353.65,
  y1: 282.99,
  x2: 423.43,
  y2: 241.12,
  gradientTransform: "translate(-230.02 281.36) rotate(47.05) scale(1 -1)",
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: 359.77,
  y1: 293.42,
  x2: 429.67,
  y2: 251.49,
  gradientTransform: "translate(-230.02 281.36) rotate(47.05) scale(1 -1)",
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: 362.84,
  y1: 298.2,
  x2: 432.57,
  y2: 256.36,
  gradientTransform: "translate(-230.02 281.36) rotate(47.05) scale(1 -1)",
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-13",
  x1: 367.55,
  y1: 306.13,
  x2: 437.32,
  y2: 264.27,
  gradientTransform: "translate(-230.02 281.36) rotate(47.05) scale(1 -1)",
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-14",
  x1: 213.56,
  y1: 371.35,
  x2: 224.88,
  y2: 424.71,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "_\\uAE08\\uC0C9",
  "data-name": "\\uAE08\\uC0C9",
  x1: -31.93,
  y1: 102.15,
  x2: 423.58,
  y2: 102.15,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fbcf00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#fffcd1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#faf3bf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#eedd92"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#dbba4b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#cb9b0c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#e7cd67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#f3e18b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fffcd1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "_\\uAE08\\uC0C9-2",
  "data-name": "\\uAE08\\uC0C9",
  x1: -31.9,
  y1: 102.49,
  x2: 423.5,
  y2: 102.49,
  xlinkHref: "#_\\uAE08\\uC0C9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "_\\uAE08\\uC0C9-3",
  "data-name": "\\uAE08\\uC0C9",
  x1: -31.94,
  y1: 102.49,
  x2: 423.6,
  y2: 102.49,
  xlinkHref: "#_\\uAE08\\uC0C9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "_\\uAE08\\uC0C9-4",
  "data-name": "\\uAE08\\uC0C9",
  x1: -31.99,
  y1: 102.49,
  x2: 423.6,
  y2: 102.49,
  xlinkHref: "#_\\uAE08\\uC0C9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "_\\uAE08\\uC0C9-5",
  "data-name": "\\uAE08\\uC0C9",
  x1: -32.02,
  y1: 102.49,
  x2: 423.61,
  y2: 102.49,
  xlinkHref: "#_\\uAE08\\uC0C9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "_\\uAE08\\uC0C9-6",
  "data-name": "\\uAE08\\uC0C9",
  x1: -31.86,
  y1: 102.49,
  x2: 423.56,
  y2: 102.49,
  xlinkHref: "#_\\uAE08\\uC0C9"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-6"
}, /*#__PURE__*/React.createElement("g", {
  id: "_\\uB808\\uC774\\uC5B4_1",
  "data-name": "\\uB808\\uC774\\uC5B4 1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "m114.03,297.65c133.75,0,248.18-70.09,294.6-169.23v-28.76c-33.23-2.01-60.56-34.96-67.78-66.53H96.65c-7.24,31.57-34.55,64.51-67.79,66.53v188.2c27.1,6.38,55.65,9.79,85.17,9.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "m359.41,0H78.09C69.75,36.31,38.28,74.3,0,76.62v223.57c0,111.83,90.64,202.5,202.45,202.5h32.57c111.83,0,202.48-90.67,202.48-202.5V76.62c-38.28-2.32-69.75-40.31-78.1-76.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "m352.72,11.95H84.79c-7.95,34.6-37.91,70.77-74.39,72.97v212.95c0,106.5,86.32,192.83,192.83,192.83h31.04c106.5,0,192.82-86.33,192.82-192.83V84.92c-36.46-2.2-66.44-38.38-74.37-72.97Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "m352.72,11.95c7.93,34.6,37.91,70.77,74.37,72.97v212.95c0,106.5-86.32,192.83-192.82,192.83h-31.04c-106.51,0-192.83-86.33-192.83-192.83V84.92c36.48-2.2,66.43-38.38,74.39-72.97h267.93m0-.91H84.79c-.43,0-.8.28-.87.7-7.78,33.8-37.42,70.09-73.59,72.26-.47.03-.84.44-.84.92v212.95c0,106.82,86.92,193.74,193.74,193.74h31.04c106.83,0,193.73-86.92,193.73-193.74V84.92c0-.48-.38-.89-.86-.92-36.16-2.17-65.78-38.45-73.54-72.26-.11-.42-.46-.7-.89-.7h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m340.85,33.15H96.65c-7.24,31.57-34.55,64.51-67.79,66.53v194.08c0,97.05,78.69,175.74,175.75,175.74h28.27c97.07,0,175.74-78.69,175.74-175.74V99.67c-33.23-2.01-60.56-34.96-67.78-66.53Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-16",
  points: "90.17 151.52 122.43 151.06 154.67 151.06 219.2 151.06 283.75 151.06 316.01 151.06 348.27 151.52 316.01 152 283.75 152 219.2 152 154.67 152 122.43 152 90.17 151.52"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "m221.58,441.4c-.11-.11-.2-.28-.29-.45-.02.13-.07.3-.11.41-1.07,2.71-3.68-.87-3.95-2.15-.86-3.67,1.49-8.04,2.14-11.69,0-.04.02-.09.02-.13,0,0,.01.13.08.36.73,2.95,3.4,4.98,4.62,7.71.64,1.44.84,2.93.29,4.49-.45,1.29-1.58,3.05-2.8,1.47Z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "m194.54,409.32c5.4-1.05,11.32-2.04,16.06.38,2.29,1.13,4.02,3.23,4.72,5.6.77,2.42.49,5.02-.66,7.19-1.11,2.12-3.17,3.79-5.27,4.12-2.01.38-4.35-.58-5.36-2.2-.51-.7-.82-2.02-.71-2.78.07-.84.62-1.51,1.62-1.98.98-.44,2.29-.53,3.4-.18,1.13.29,2.02,1.2,1.87,2.6l.32.11c.9-1.34-.03-3.42-1.5-4.2-1.43-.8-3.09-1.04-4.8-.71-1.67.24-3.51,1.68-3.98,3.67-.17.47-.2.92-.2,1.38s-.02.93.11,1.33c.16.81.31,1.71.78,2.57,1.89,3.24,5.73,4.68,9.2,3.82,3.38-.9,5.84-3.44,7.09-6.33,1.27-2.88,1.4-6.24.29-9.14-1.09-2.93-3.4-5.31-6.2-6.49-5.74-2.24-11.58-.58-16.86.9l.07.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "m198.23,415.56c-2.16.31-4.22.89-6.22,1.69-1,.42-2.18.64-2.93,1.48-.76.86-1.38,1.89-1.47,3.32l.24.24c1.42,0,2.38-.29,3.33-.67.93-.36,1.47-1.28,2.27-1.91,1.56-1.28,3.2-2.58,4.91-3.81l-.13-.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "m196.76,413.87c-3.38-.04-6.74.36-10.06,1.16-1.67.38-3.46.62-4.91,1.6-1.48.95-2.82,2.18-3.64,3.91l.2.3c1.91-.11,3.44-.54,4.98-1.02,1.52-.41,2.8-1.46,4.29-2.1,2.95-1.34,6.01-2.51,9.18-3.49l-.02-.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "m189.58,411.25c-4,.11-8,.55-11.93,1.43-1.96.43-4.05.68-5.87,1.79-1.74,1.07-3.56,2.44-4.42,4.53l.24.27c2.09-.53,3.84-1,5.65-1.55,1.78-.53,3.43-1.61,5.21-2.31,3.6-1.42,7.35-2.67,11.15-3.8l-.05-.36Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "m244.14,408.18c-5.25-1.56-11.08-3.33-16.85-1.2-2.82,1.13-5.17,3.49-6.29,6.38-1.18,2.88-1.11,6.24.11,9.15,1.2,2.91,3.61,5.5,6.98,6.46,3.44.92,7.32-.46,9.25-3.68.49-.83.68-1.72.83-2.53.11-.38.11-.87.11-1.33.02-.46,0-.92-.16-1.39-.43-1.99-2.24-3.45-3.93-3.74-1.66-.33-3.33-.13-4.79.64-1.48.78-2.46,2.82-1.59,4.2l.36-.12c-.16-1.43.76-2.31,1.89-2.58,1.12-.34,2.42-.21,3.41.23,1,.49,1.53,1.16,1.59,2,.07.76-.24,2.09-.77,2.8-1.04,1.56-3.41,2.49-5.39,2.08-2.12-.39-4.13-2.06-5.22-4.19-1.07-2.2-1.31-4.82-.53-7.21.76-2.37,2.51-4.43,4.87-5.54,4.77-2.31,10.67-1.24,16.02-.07l.1-.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "m240.13,415.03c1.69,1.29,3.3,2.59,4.84,3.9.78.66,1.32,1.59,2.24,1.97.91.4,1.87.7,3.29.73l.27-.27c-.07-1.43-.69-2.47-1.42-3.33-.71-.87-1.91-1.11-2.89-1.51-2.01-.86-4.08-1.47-6.2-1.81l-.13.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "m241.69,413.38c3.2,1.05,6.24,2.29,9.15,3.64,1.47.69,2.73,1.73,4.25,2.19,1.52.5,3.03.97,4.95,1.1l.22-.28c-.81-1.77-2.13-3.02-3.57-3.99-1.46-1.02-3.23-1.27-4.88-1.69-3.33-.87-6.7-1.29-10.06-1.31l-.07.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "m248.93,410.89c3.78,1.19,7.49,2.49,11.06,4,1.78.73,3.41,1.83,5.18,2.38,1.81.61,3.55,1.11,5.62,1.67l.27-.26c-.86-2.1-2.61-3.52-4.36-4.63-1.77-1.12-3.87-1.4-5.84-1.87-3.93-.96-7.89-1.44-11.86-1.64l-.07.36Z"
}))), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-20",
  points: "90.17 398.03 122.43 397.56 154.67 397.56 219.2 397.56 283.75 397.56 316.01 397.56 348.27 398.03 316.01 398.52 283.75 398.52 219.2 398.52 154.67 398.52 122.43 398.52 90.17 398.03"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m130.57,91.05c-.13-2.29-.91-3.92-2.33-4.87-1.43-.96-3.39-1.46-5.9-1.46-2.38,0-4.2.52-5.51,1.5-1.3,1-1.89,2.59-1.82,4.83.04,1.13.51,2.08,1.38,2.85.88.77,1.92,1.41,3.13,1.95,1.2.52,2.47.96,3.79,1.28,1.32.33,2.42.6,3.25.84,2.19.67,4.19,1.44,5.97,2.28,1.8.82,3.38,1.82,4.67,2.96,1.29,1.17,2.31,2.52,3.02,4.07.73,1.57,1.11,3.44,1.11,5.62,0,2.8-.51,5.17-1.51,7.15-1,1.94-2.36,3.52-4.11,4.7-1.74,1.21-3.75,2.04-6.05,2.56-2.31.49-4.79.7-7.38.63-2.71-.08-5.18-.46-7.4-1.15-2.2-.7-4.11-1.74-5.72-3.12-1.59-1.37-2.83-3.09-3.77-5.19-.91-2.09-1.44-4.56-1.56-7.43h9.61c.08,2.79.94,4.93,2.59,6.4,1.62,1.48,3.78,2.24,6.47,2.27,3.04.07,5.33-.43,6.85-1.42,1.53-.98,2.24-2.82,2.13-5.49-.04-1.26-.38-2.28-.98-3.09-.62-.82-1.41-1.51-2.43-2.07-1-.58-2.17-1.06-3.51-1.47-1.36-.4-2.75-.84-4.2-1.27-1.69-.46-3.44-1.01-5.24-1.64-1.81-.66-3.43-1.49-4.9-2.53-1.48-1.03-2.65-2.32-3.61-3.84-.97-1.55-1.44-3.43-1.44-5.66,0-2.42.47-4.58,1.31-6.44.87-1.88,2.07-3.42,3.6-4.64,1.5-1.26,3.31-2.2,5.44-2.83,2.09-.66,4.39-.98,6.84-.98,2.82,0,5.29.34,7.5,1.03,2.16.68,4.01,1.67,5.56,2.94,1.49,1.27,2.68,2.83,3.49,4.65.83,1.83,1.29,3.85,1.35,6.08h-9.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "m155.16,111.17v15.88h-9.83v-49.13h18.79c2.9,0,5.39.54,7.43,1.65,2.06,1.1,3.71,2.47,4.98,4.13,1.29,1.66,2.21,3.45,2.8,5.39.59,1.95.88,3.78.88,5.47s-.29,3.53-.88,5.48c-.58,1.92-1.51,3.74-2.79,5.37-1.27,1.63-2.91,3.02-4.97,4.1-2.04,1.09-4.51,1.65-7.44,1.65h-8.97Zm6.08-8.21c2.89,0,5.15-.67,6.73-2.1,1.6-1.39,2.4-3.49,2.4-6.29s-.8-4.84-2.4-6.25c-1.58-1.42-3.84-2.12-6.73-2.12h-6.08v16.76h6.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "m176.7,127.05l16.2-49.13h9.81l16.23,49.13h-9.49l-2.98-9.08h-17.4l-2.91,9.08h-9.47Zm21.06-35.92l-6.12,18.84h12.22l-6.1-18.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "m250.25,127.05l-8.7-19.22h-8.89v19.22h-9.87v-49.13h20.33c2.92,0,5.33.47,7.32,1.39,1.97.95,3.54,2.12,4.75,3.53,1.21,1.42,2.08,2.98,2.59,4.71.51,1.67.73,3.29.73,4.86,0,1.21-.09,2.38-.31,3.54-.23,1.15-.62,2.27-1.22,3.34-.58,1.06-1.38,2.09-2.42,3.05-1.02.94-2.31,1.8-3.89,2.58l10.04,22.13h-10.48Zm-17.59-27.48h7.14c1.3,0,2.48-.11,3.57-.28,1.09-.18,2.03-.53,2.81-1.03.8-.51,1.39-1.18,1.83-2.08.44-.85.67-1.99.67-3.35s-.22-2.49-.67-3.36c-.45-.84-1.03-1.53-1.83-1.99-.78-.49-1.72-.82-2.81-.99-1.09-.18-2.27-.28-3.57-.28h-7.14v13.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "m272.83,86.2h-12.29v-8.28h34.41v8.28h-12.26v40.85h-9.85v-40.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "m291,127.05l16.23-49.13h9.78l16.22,49.13h-9.46l-2.98-9.08h-17.4l-2.91,9.08h-9.48Zm21.08-35.92l-6.13,18.84h12.22l-6.09-18.84Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m200.76,207.48h-34.9v-4.27h38.58v-16.75c0-10.17-2.38-13.11-15.39-13.11h-70.26c-13.02,0-15.4,2.94-15.4,13.11v3.61c0,10.19,2.38,13.14,15.4,13.14h23.15v4.27h-34.88c-6.27,0-8.51,3.04-8.51,6.29,0,3.42,2.37,6.17,8.51,6.17h93.69c6.15,0,8.53-2.75,8.53-6.17s-2.27-6.29-8.53-6.29Zm-71.56-16.45c-2.13,0-2.24-.58-2.24-2.28v-1.03c0-1.51.11-2.19,2.24-2.19h49.43c2.14,0,2.24.68,2.24,2.19v3.32h-51.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m201.36,250.67h-71.82c-1.76,0-2.22-.67-2.22-1.72,0-.94.47-1.61,2.22-1.61h74.91v-14.75c0-5.78-3.2-8.83-13.27-8.83h-81.39c-4.72,0-6.72,2.85-6.72,5.32s2.35,5.23,6.72,5.23h68.01c1.76,0,2.26.48,2.26,1.53v1.7h-63.28c-10.29,0-14.91,4.67-14.91,11.32v.29c0,6.46,4.74,12.15,14.91,12.15h84.58c4.73,0,6.38-3.04,6.38-5.31,0-2.66-1.78-5.32-6.38-5.32Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m293.26,197.88v-2.95c0-15.4-13.73-21.59-33.83-21.59s-33.85,6.19-33.85,21.59v2.95c0,15.43,13.74,21.6,33.85,21.6s33.83-6.17,33.83-21.6Zm-44.48.85v-4.65c0-4.75,4.38-7.13,10.65-7.13s10.63,2.38,10.63,7.13v4.65c0,4.87-4.37,7.14-10.63,7.14s-10.65-2.28-10.65-7.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m319.4,223.17c-6.14,0-11.12,2.31-11.83,7.62h-52.99c-.83-5.24-5.58-7.62-11.6-7.62-6.62,0-11.93,2.69-11.93,9.14v15.13c0,10.17,3.53,13.86,16.79,13.86h83.29v-28.98c0-6.38-5.09-9.14-11.72-9.14Zm-11.94,25.49h-49.57c-2.6,0-3.2-.28-3.2-2.37v-3.33h52.77v5.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m330.51,181.43c0-6.11-5.77-9.4-11.94-9.4s-11.94,3.23-11.94,9.4v38.8h23.89v-38.8Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m199.35,319.09h-41.17v-5.51c0-6.09-5.92-8.29-12.08-8.29s-12.06,2.11-12.06,8.29v5.51h-25.54c-7.2,0-9.93,3.64-9.93,7.42s2.84,7.53,9.93,7.53h90.85c7.1,0,9.94-3.64,9.94-7.53s-2.73-7.42-9.94-7.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m181.84,338.48h-55.84c-16.33,0-24.13,6.95-24.13,17.13s7.8,16.95,24.13,16.95h55.84c16.34,0,24.12-6.69,24.12-16.95s-7.78-17.13-24.12-17.13Zm-5.9,20.46h-44.02c-4.74,0-6.02-1.23-6.02-3.33s1.28-3.13,6.02-3.13h44.02c4.7,0,6.02,1.04,6.02,3.13s-1.32,3.33-6.02,3.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m113.71,299.51h62.69c2.12,0,2.97.84,2.97,2.09v1.32c0,5.06-1.07,9.14-2.49,12.54h23.17c1.42-3.4,2.84-9.4,2.84-16.73v-3.7c0-6.84-4.38-10.76-15.85-10.76h-73.33c-7.81,0-10.88,3.42-10.88,7.53,0,4.38,3.18,7.71,10.88,7.71Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m291,303.87v-5.04c0-8.54-4.37-12.85-17.25-12.85h-36.08c-6.98,0-9.71,3.91-9.71,7.62s2.84,7.62,9.71,7.62h26.95c1.79,0,2.73.58,2.73,2.09v1.03c0,11.23-13.61,16.93-31.24,16.65-5.67-.11-9.82,2.29-10.16,6.75-.37,5.04,4.03,8.38,9.34,8.64,29.71,1.82,55.71-9.62,55.71-32.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m321.41,357.52h-61.98c-2.61,0-3.21-.27-3.21-2.38v-5.53c0-6.38-5.21-9.4-11.82-9.4s-12.18,2.93-12.18,9.4v8.78c0,10.18,3.53,13.87,16.78,13.87h72.41c7.11,0,9.95-3.51,9.95-7.41s-2.73-7.32-9.95-7.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m331.01,306.73h-3.69v-14.38c0-6.07-5.44-9.4-11.58-9.4s-11.6,3.22-11.6,9.4v57.84h23.17v-26.91h3.69c7.09,0,9.33-4.39,9.33-8.29s-2.13-8.26-9.33-8.26Z"
})))));

function SvgJust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 437.51 502.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJust);
export default __webpack_public_path__ + "static/media/just.2cdb05ba.svg";
export { ForwardRef as ReactComponent };